/* global gtag */
import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';

import { openPopup, addComma } from './utils';
import { cuCounter } from './cu-counter';
import { gameStarter, userGameStatus } from './game-starter';
import { message } from './message/message-model';
import { MessageView } from './message/message-view';
import { userInfo, UserInfoView } from './user-info';
import { GiftCashView } from './gift-cash';
import { PmlayerModel, getValueFromPmlayerDOM } from './pmlayer/pmlayer-model';
import { PmlayerView } from './pmlayer/pmlayer-view';

// 개인암호
import { PasswdModel } from './mfa/passwd/passwd-model';
import { PasswdView } from './mfa/passwd/passwd-view';

// 보안SMS
import { SecureSMSModel } from './mfa/secure-sms/secure-sms-model';
import { SecureSMSView } from './mfa/secure-sms/secure-sms-view';

// 이벤트 버스
import { eventBus } from './state-manager/event-bus';
import { handleError, ERRORS } from './utils/handle-error';

// 정기결제
import { SubscriptionModel } from './membership/subscription-model';
import { SubscriptionView } from './membership/subscription-view';

// 웹푸시
import { createWebPushManager } from './fcm/web-push';

export var AppView = Backbone.View.extend({
  el: '.app__main',

  eventBus: eventBus,

  initialize: function () {
    _.bindAll(
      this,
      'runGame',
      'watchPopups',
      'popupOnClose',
      'openWindowPopup',
      'checkMaintenance'
    );

    this.state = this.model; // state는 AppView 생성 시 주입
    this.game = this.state.get('game');
    this.gameName = this.state.get('gameName');

    this.openedPopups = [];
    this.unregWatchPop = _.noop;

    this.isLive = this.state.get('env') === 'live';
    this.isUnderMaintaining = this.state.get('maintenance');

    if (this.$('.app__message').length > 0) {
      this.message = message;
      new MessageView({ model: this.message });

      this.eventBus.on(
        'show:message',
        _.bind(function (e) {
          this.message.show(e.title, e.message, e.onConfirm, e.option);
        }, this)
      );
    }

    if (this.$('.app__user-info').length > 0 && Boolean(this.state.get('nickname'))) {
      this.userInfo = userInfo;
      this.userInfoView = new UserInfoView({ model: this.userInfo });
      this.userInfo.fetch({ game: this.game });
    }

    if (!this.isUnderMaintaining) {
      this.cuCounter = cuCounter;
      this.cuCounter.startPolling(this.game, 20, 15); // 20초에 한번 최대 15번까지만
      this.listenTo(this.cuCounter, 'change', this.renderCUCounter);
    }

    if (this.$('.user__info').length > 0) {
      new GiftCashView();

      // Firebase 웹푸시, 오른쪽 사이드바가 있을 경우만, 뉴맞고에서만
      if (this.game === 'newmatgo') {
        var envName = this.state.get('env').toUpperCase();
        var webPush = createWebPushManager(envName, this.game);

        webPush
          .requestPermission()
          .then((hasPermission) => {
            if (hasPermission) {
              return webPush.registerSubscription();
            }
            throw new Error('FCM Permission Denied');
          })
          .then((registered) => {
            if (registered) {
              console.log('FCM Registered');
              return webPush.addMessageHandler();
            }
          })
          .catch((error) => {
            console.log('FCM', error);
          });
      }
    }

    // 정기결제
    if (this.$('.app__subscription-page').length > 0) {
      this.subscription = new SubscriptionModel();
      this.subscriptionView = new SubscriptionView({ model: this.subscription });
      this.$('.app__subscription-page').html(this.subscriptionView.el);
    }

    this.layerPopups = [];
    this.createLayerPopups();

    this.checkMaintenance(); // 점검 상태라면 팝업으로 안내 표시
  },

  events: {
    'click .app__game-start': 'runGame',
    'click [data-link-to=game]': 'showPrelude',
    'click [data-popup]': 'openWindowPopup',
    'click [data-link-to=_blank]': 'openNewWindow',
    'click [data-link-to=howPcbang]': 'showHowPcbang',
    'click .nav-special__recharge': 'showTemporaryError',
    'click [data-msg-popup]': 'showMessagePopup',
    'click [data-app-role]': 'reportClickAction'
  },

  render: function () {
    return this; // 이 뷰는 직접 렌더링을 하지 않고 DOM에 이벤트 바인딩만 함
  },

  renderCUCounter: function () {
    var count = this.cuCounter.get('count');
    var countWithComma = addComma(count);
    $('.game-start__status').html('현재 접속자 수 : ' + countWithComma + '명');
  },

  switchGame: function (game) {
    this.state.setGame(game);
    this.game = this.state.get('game');
    this.gameName = this.state.get('gameName');
  },

  checkMaintenance: function (e) {
    if (this.isUnderMaintaining) {
      if (e && _.isFunction(e.preventDefault)) e.preventDefault();

      var maintenanceError = new Error('Under maintenance');
      maintenanceError.code = ERRORS.Maintenance; // 점검
      handleError(maintenanceError);

      this.message.show('main');

      return true;
    } else {
      return false;
    }
  },

  runGame: function () {
    if (this.state.get('guest')) {
      this.login();
      return;
    }

    if (this.checkMaintenance() && this.isLive) return;

    var isMFADeprecated = this.state.checkMFADeprecated();
    var gameSSN = this.state.get('ssn');
    var gameInfoSrl = this.state.get('gameInfoSrl');
    var channelLabel = 1; // 고스톱군은 채널 구분 없이 실행

    var agent = navigator.userAgent.toLowerCase();

    if (agent.indexOf('windows nt 5.1') >= 0) {
      this.message.show(
        '게임 실행 안내',
        ['죄송합니다.', '윈도우 XP에서는 게임을 실행하실 수 없습니다.'].join('')
      );
      return;
    }

    if (isMFADeprecated) {
      this.message.show(
        '보안 서비스 안내',
        [
          '웹보드 게임에서 지원하지 않는<br>',
          '보안서비스를 이용하고 계십니다.<br>',
          '<strong>"개인암호"</strong>나 <strong>"보안SMS"</strong>로 변경하시면<br>',
          '웹보드 게임을 안전하게 이용하실 수 있습니다.'
        ].join('')
      );
      return;
    }

    this.checkMFA()
      .then(
        _.bind(function () {
          return gameStarter.fetchParams(this.game, gameSSN, gameInfoSrl, channelLabel);
        }, this)
      )
      .then(gameStarter.launch)
      .then(gameStarter.sendOSInfo)
      .then(function () {
        var launcherType = $.browser.msie ? 'AX' : 'CU';
        if (window.gtag) {
          window.gtag('event', 'click', {
            event_category: 'game_start',
            event_label: 'ssn:' + gameSSN + '_type:' + launcherType
          });
        }
      })
      .catch(handleError);
  },

  checkMFA: function () {
    var triggerSuccess = function () {
      $(document).trigger('app:authSuccess');
      return true;
    };

    var triggerFail = function (err) {
      $(document).trigger('app:authFail', { err: err });
      return err;
    };

    return new Promise(
      _.bind(function (resolve, reject) {
        var isMFADeprecated = this.state.checkMFADeprecated();
        var isAuthRequired = this.state.checkMFAActivated();
        var serviceType = this.state.get('mfaServiceType');
        var mfaServiceView;
        var deprecatedError;

        if (isMFADeprecated) {
          deprecatedError = new Error('MFA deprecated');
          deprecatedError.code = ERRORS.MFADeprecated;
          reject(handleError(triggerFail(deprecatedError)));
          return;
        }

        if (!isAuthRequired) {
          // 다른 모듈에서 pub/sub를 프라미스로 래핑해서 결과를 받을 경우, 살짝 지연하지 않으면 subscribe 하기 전에 resolve 된다.
          _.delayed(function () {
            resolve(triggerSuccess());
          }, 10);
          return;
        }

        if (serviceType === 'PASSWD') {
          mfaServiceView = new PasswdView({
            model: new PasswdModel()
          });
        } else if (serviceType === 'SMS') {
          mfaServiceView = new SecureSMSView({
            model: new SecureSMSModel()
          });
        } else {
          reject(new Error('Unknown MFA Service'));
          return;
        }

        mfaServiceView.on('success', function () {
          mfaServiceView.remove();
          resolve(triggerSuccess());
        });

        mfaServiceView.on('fail', function (e) {
          var err = new Error(e.resultText || 'MFA failed');
          err.code = e.resultCode;
          err.description = e.resultText;
          mfaServiceView.remove();
          reject(handleError(triggerFail(err)));
        });

        $('.app__mfa').html(mfaServiceView.render().el);
      }, this)
    );
  },

  showPrelude: function (e) {
    e.preventDefault();

    if (this.state.get('guest')) {
      this.login();
      return;
    }

    var href = $(e.currentTarget).attr('href').split('/').pop();

    var title = '이벤트 참여';
    var menu = '이벤트';

    if (href === 'Store') {
      title = '상품 구매';
      menu = '상점';
    }

    userGameStatus.checkPlaying(this.game).done(
      _.bind(function (isPlaying) {
        this.preludeMessage(isPlaying, title, menu);
      }, this)
    );
  },

  // eslint-disable-next-line no-unused-vars
  preludeMessage: function (isPlaying, title, menu) {
    if (isPlaying) {
      this.message.show(
        '게임 실행 안내',
        '게임이 실행 중입니다.<br>상세정보는 게임에서 확인하실 수 있습니다.'
      );
    } else {
      this.message.showPrelude(
        '<strong>게임을 실행하시면</strong><br>상세한 내용을<br>확인하실 수 있습니다.',
        this.runGame
      );
    }
  },

  openWindowPopup: function (e) {
    if (e && _.isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    var $target = $(e.currentTarget);
    var dataset = $target.data();

    var popName = dataset.popup;
    var width = dataset.popupWidth;
    var height = dataset.popupHeight;
    var onClose = dataset.popupOnClose;
    var scrollbars = dataset.popupScrollbars || 'yes';

    var opened = openPopup($target.attr('href'), popName, {
      width: width,
      height: height,
      scrollbars: scrollbars
    });

    if (onClose) {
      this.openedPopups.push({
        ref: opened,
        name: popName,
        onClose: onClose
      });

      this.unregWatchPop();
      this.unregWatchPop = _.repeat(this.watchPopups, 500);
    }
  },

  watchPopups: function () {
    if (this.openedPopups.length > 0) {
      _.each(
        this.openedPopups,
        _.bind(function (pop, i) {
          if (pop.ref && pop.ref.closed) {
            this.popupOnClose(pop.onClose, i);
          }
        }, this)
      );
    } else {
      this.unregWatchPop();
    }
  },

  popupOnClose: function (onClose, index) {
    var cbChunk = onClose.split(':'); // app:viewName:eventName 형식
    if (cbChunk[0] === 'app') {
      this[cbChunk[1]].trigger(cbChunk[2]);
    }
    this.openedPopups.splice(index, 1);
  },

  openNewWindow: function (e) {
    e.preventDefault();

    var $el = $(e.currentTarget);
    return window.open($el.attr('href'));
  },

  showHowPcbang: function (e) {
    e.preventDefault();

    if (this.state.get('guest')) {
      this.login();
      return;
    }

    userGameStatus.checkPlaying(this.game).done(
      _.bind(function (isPlaying) {
        if (isPlaying) {
          this.message.show(
            '하우’PC방 안내',
            [
              '<strong>하우’PC방 쿠폰은 [뉴스팝업]→[하우PC방 선물도착] 배너의<br>[대박복권 받기] 버튼을 터치 시 지급됩니다.</strong><br>',
              '전용 고스톱몰 상품은 게임 내<br>',
              '<strong>‘스페셜몰’</strong>에서 확인하실 수 있습니다.'
            ].join('')
          );
        } else {
          this.message.set({
            title: '하우’PC방 안내',
            message: [
              '<strong>하우’PC방 쿠폰은 [뉴스팝업]→[하우PC방 선물도착] 배너의<br>[대박복권 받기] 버튼을 터치 시 지급됩니다.</strong><br>',
              '전용 고스톱몰 상품은 게임 실행 후<br>',
              '<strong>‘스페셜몰’</strong>에서 확인하실 수 있습니다.'
            ].join(''),
            onConfirm: _.bind(this.runGame, this),
            confirmText: '실행',
            hasConfirm: true,
            isVisible: true
          });
        }
      }, this)
    );
  },

  createLayerPopups: function () {
    this.$('.app__pmlayer').each(
      _.bind(function (idx, el) {
        var pmlayer = new PmlayerModel(getValueFromPmlayerDOM(el));
        new PmlayerView({ model: pmlayer, el: el });
        this.layerPopups.push(pmlayer);
      }, this)
    );

    if (this.layerPopups.length > 0) {
      this.layerPopups[0].setVisible(true);
    }
  },

  showMessagePopup: function (e) {
    e.preventDefault();
    var dataset = $(e.currentTarget).data();
    switch (dataset.msgPopup) {
      case 'prepareClass':
        this.message.set({
          title: '안내',
          message: ['새로운 <strong>클래스</strong>를 준비중입니다.'].join(''),
          cancelText: '닫기',
          hasCancel: true,
          isVisible: true,
          onConfirm: null
        });
        break;
    }
  },

  showTemporaryError: function (e) {
    e.preventDefault();
    $(e.target).attr('href', '#');
    this.message.show('죄송합니다', '무료충전소 서비스가 현재 점검중이라<br>이용하실 수 없습니다.');
  },

  login: function (e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    var loginUrl = this.state.get('loginUrl');
    setTimeout(function () {
      location.assign(loginUrl);
    }, 100); // 혹시 몰라서 gtag 이벤트 보낼 시간을 확보
  },

  reportClickAction: function (e) {
    if (!this.state.get('guest')) {
      return;
    }

    var $target = $(e.currentTarget);
    var role = $target.data('app-role') || 'not_set';
    var href = $target.attr('href') || 'not_set';
    var text = $target.text() || $target.attr('class') || 'not_set';
    var label = [text, href].join(':');

    if (typeof gtag === 'function') {
      gtag('event', role, {
        event_category: 'login_action',
        event_label: label
      });
    } else {
      console.log(
        'Failed to send GA event - Category: login_action',
        '/ Action:',
        role,
        '/ Label:',
        label
      );
    }
  }
});
